<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
export default {
  name: 'App',
  mounted() {
    window.onresize = ()=>{
      this.resize()
    }
  },
  created() {
    this.resize()
  },
  watch: {
    // 路由切换时重新计算布局，保证独立页面与业务页面互不影响
    '$route'() {
      this.resize()
    }
  },
  methods:{
    // 独立页面：完全脱离 App.vue 的 1920px 缩放布局
    isStandaloneRoute() {
      return this.$route && this.$route.path.indexOf('/deviceupgrade') === 0
    },
    resize(){
      // 独立页面：重置 body 样式，保持纯净布局，不受 App.vue 影响
      if (this.isStandaloneRoute()) {
        document.body.style.width = ''
        document.body.style.transform = ''
        document.body.style.transformOrigin = ''
        document.body.style.height = ''
        document.body.style.overflow = 'auto'
        document.documentElement.style.overflow = 'auto'
        return
      }
      var scale = 1
      scale = (window.innerWidth)/1920
      document.body.style.width = '1920px'
      document.body.style.transform = `scale(${scale})`
      document.body.style.transformOrigin = `0 0`
      document.body.style.height = `${100/scale}%`
      document.body.style.overflow = ''

      // 新增：每次缩放后修复下拉框
      this.fixSelectDropdown(scale)
    },
    // 新增：修复下拉框偏移的核心方法
    fixSelectDropdown(scale) {
      // 延迟执行，确保下拉框已渲染
      setTimeout(() => {
        const dropdowns = document.querySelectorAll('.el-select-dropdown')
        dropdowns.forEach(dd => {
          dd.style.transform = `scale(${1/scale})` // 反向缩放抵消body缩放
          dd.style.transformOrigin = '0 0'
          dd.style.zIndex = '9999'
        })
      }, 100)
    }
  }
}
</script>

<style lang="less">
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100%;
  width: 100%;
}

*{
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}
html,body{
  width: 100%;
  height: 100%;
  padding-right: 0px!important;
  position: relative; // 新增：让下拉框定位参考body
  overflow: hidden;
}
@media screen and ( max-height: 1100px )  {
  html{
    font-size: 10px;
  }
}
@media screen and ( min-height: 1100px ) and ( max-height: 1500px ) {
  html{
    font-size: 15px;
  }
}
@media screen and ( min-height: 1500px ){
  html{
    font-size: 20px;
  }
}
.anchorBL{
  display: none!important;
}
.outside .ec-extension-bmap{
  background-color: #003267!important;
}
.outside .BMap_mask{
  box-shadow: 0 0 40px 40px rgba(4 ,27 ,58 ,1) inset !important;
}
.el-icon-loading{
  font-size:20px!important;
}
.el-loading-text{
  font-size: 20px!important;
}

// 新增：仅修复下拉框定位，不碰任何其他样式
.el-select-dropdown {
  position: absolute !important;
  z-index: 9999 !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue